



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Member } from '../../models/member.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { Subject } from 'rxjs';
import { MemberAccess } from '../../models/member-access.model';
import { MemberAccessActionType } from '../../models/enums';

@Component({
    selector: 'file-detail',
    template: require('./file-detail.component.html'),
    styles: [require('./file-detail.component.css')],
    animations: [fadeInOut]
})
export class FileDetailComponent {
    searchText: string;
    isGettingMembers = false;
    memberDetailsParams: any = {};
    history: Member[] = [];
    currentUser: User;
    isSearching = false;
    fileDetailPagedResult : any= {
        results: [],
        rowCount: 0,
        currentPage: 1,
        pageSize: 20
    };
    totalHistory: any;
    fileName ="";

    //page = {
    //    pageNumber: 1,
    //    size: 10,
    //}

    private subject: Subject<string> = new Subject();

    constructor(private router: Router, private apiService: ApiService, private authService: AuthService,
        private activateRouter: ActivatedRoute,
        public dialog: MatDialog, private alertService: AlertService) {

        this.fileName = this.activateRouter.snapshot.queryParams.name;
        this.getPagedResult(this.fileName, this.fileDetailPagedResult.currentPage, this.fileDetailPagedResult.pageSize);
        

    }

    //getTotalHistory() {
    //    this.apiService.getAllMemberAccessLastRecords().subscribe(r => {
    //        this.totalHistory = r.length;
    //        console.log(this.totalHistory)
    //    })
    //}

    onRefresh() {
        this.fileDetailPagedResult.results = [];
        this.fileDetailPagedResult.currentPage = 0;
        this.getPagedResult(this.fileName, this.fileDetailPagedResult.currentPage + 1, this.fileDetailPagedResult.pageSize);
    }

    getChangePage(page) {
       // this.page.pageNumber = page.offset
        //console.log(this.page)
        this.fileDetailPagedResult.results = [];
        this.getPagedResult(this.fileName, page.offset + 1, this.fileDetailPagedResult.pageSize);
    }


    getPagedResult(fileName, page, pageSize) {
        this.apiService.getInboundFileDetail(fileName, page, pageSize).subscribe(r => {
            this.fileDetailPagedResult = r;
            //this.fileDetailPagedResult.currentPage--;
            console.log(this.fileDetailPagedResult)
        })
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/file-detail/file-detail.component.ts